module.exports = __webpack_public_path__ + "media/components/weather-icon/static/daythunderstorm-1ae53742ae4984c555f6ed4a663cf45f.png";